import styled, { css } from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import { HeaderLinkStyle as HeaderLink } from "../../../BaseComponents/Link/BaseLink";

export const ArticleWrapper = styled.div.attrs(({ isPriorityItem }) => ({}))`
  flex-basis: ${({ isPriorityItem }) => (isPriorityItem ? "100%" : "33%")};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.border.radius};
  display: flex;
  flex-direction: column;
  width: auto;
  margin: 0rem;
  border: 1px solid ${({ theme }) => theme.colors.grey};
  outline: none;
  transition: all 0.2s ease;
  cursor: pointer;
  min-height: ${({ isPriorityItem }) => (isPriorityItem ? "420px" : "220px")};

  ${media.greaterThan(breakpoints.ipad)`
		max-width: ${({ isPriorityItem }) => (isPriorityItem ? "100%" : "50%")};
		flex-direction: ${({ isPriorityItem }) => (isPriorityItem ? "row" : "column")};
	`}

  ${media.greaterThan(breakpoints.mobile)`
        min-height: auto;
        flex-grow: 1;
        &:first-of-type {
		margin-left: 0;
	}
	&:last-of-type {
		margin-right: 0;
	}

        flex-wrap: nowrap;
  `} &:hover, &:focus {
    & > div:first-of-type {
      opacity: 0.7;
    }

    ${HeaderLink} {
      span {
        border-color: black;
      }
    }
  }
`;
